var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserSetting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66667 10.8333V17.5H0C0 13.8181 2.98477 10.8333 6.66667 10.8333ZM6.66667 10C3.90417 10 1.66667 7.7625 1.66667 5C1.66667 2.2375 3.90417 0 6.66667 0C9.42917 0 11.6667 2.2375 11.6667 5C11.6667 7.7625 9.42917 10 6.66667 10ZM8.82883 14.8429C8.77725 14.6259 8.75 14.3995 8.75 14.1667C8.75 13.9339 8.77725 13.7075 8.82875 13.4905L8.00242 13.0134L8.83575 11.57L9.66267 12.0474C9.99025 11.7376 10.3897 11.5028 10.8333 11.3708V10.4167H12.5V11.3708C12.9437 11.5028 13.343 11.7376 13.6706 12.0474L14.4976 11.5699L15.331 13.0133L14.5046 13.4904C14.5561 13.7075 14.5833 13.9339 14.5833 14.1667C14.5833 14.3994 14.5561 14.6258 14.5046 14.8428L15.331 15.3199L14.4977 16.7633L13.6707 16.2858C13.3431 16.5957 12.9438 16.8305 12.5001 16.9625V17.9167H10.8334V16.9626C10.3897 16.8306 9.99033 16.5958 9.66275 16.2859L8.83583 16.7634L8.00242 15.32L8.82883 14.8429ZM11.6667 13.3333C11.2064 13.3333 10.8333 13.7064 10.8333 14.1667C10.8333 14.6269 11.2064 15 11.6667 15C12.1269 15 12.5 14.6269 12.5 14.1667C12.5 13.7064 12.1269 13.3333 11.6667 13.3333Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserSetting);
export default __webpack_public_path__ + "static/media/user-setting.5b283bbedc534a88b345020979dc9aa8.svg";
export { ForwardRef as ReactComponent };